import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// 기본 페이지 제목
const DEFAULT_TITLE = "평강제일교회 업무 포털";

const PageTitle = ({ title }) => {
	const location = useLocation();

	useEffect(() => {
		// title이 제공되면 사용하고, 없으면 기본값 사용
		const pageTitle = title || DEFAULT_TITLE;
		document.title = pageTitle;

		// 컴포넌트가 언마운트될 때 기본값으로 복원
		return () => {
			document.title = DEFAULT_TITLE;
		};
	}, [location, title]);

	return null;
};

export default PageTitle;
